import { TResultType } from 'legacy/lut/classes/models/partner360/ELT/financialData/kpi/IKpi'

interface IMergeColumns {
  rowResults: Record<string, TResultType[] | null>
  columns: string[]
}

export const mergeColumns = ({ rowResults, columns }: IMergeColumns) => {
  if (!rowResults) {
    return columns.map(() => ({ value: '', colSpan: 1, items: [] }))
  }

  return columns.reduce<{ value: string; colSpan: number; items: TResultType[] }[]>(
    (mergedCells, col, index) => {
      const items = rowResults[col] || []
      const value = JSON.stringify(items)

      if (index > 0 && mergedCells[mergedCells.length - 1].value === value) {
        mergedCells[mergedCells.length - 1].colSpan++
      } else {
        mergedCells.push({ value, colSpan: 1, items })
      }

      return mergedCells
    },
    []
  )
}
